import { Component, OnInit } from '@angular/core';
import { OrderModel } from 'src/app/store/order/model';

@Component({
  selector: 'app-order-bread-crump',
  templateUrl: './order-bread-crump.component.html',
  styleUrls: ['./order-bread-crump.component.scss'],
  standalone: false,
})
export class OrderBreadCrumpComponent implements OnInit {
  order: OrderModel;

  constructor() {}

  ngOnInit(): void {}
}
